import { Component, Inject, OnInit, OnDestroy, Optional, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { StartupService } from '@core';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { DA_SERVICE_TOKEN, ITokenService, SocialOpenType, SocialService } from '@delon/auth';
import { SettingsService, _HttpClient } from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { AccountService } from 'src/app/modules/service/account/account.service';
import { CommonService } from 'src/app/modules/service/common/common.service';
import { LoginService } from 'src/app/modules/service/login/login.service';
import { SlideVerifyComponent } from '../../../modules/component/slide-verify/slide-verify.component';

@Component({
  selector: 'passport-password-set',
  templateUrl: './password-set.component.html',
  styleUrls: ['./password-set.component.less'],
  providers: [SocialService],
})
export class PasswordSetComponent implements OnInit, OnDestroy {
  @ViewChild('slideVerifier1', { static: false }) slideVerifier1: SlideVerifyComponent;

  verifyShow = false;

  type = 2;
  error = {
    password: false,
    password2: false,
    passwordNew: false,
    passwordNew2: false,
  };
  // 初次登录
  key = '';
  user = '';
  passwordVisible = false;
  password: string = '';
  passwordVisible2 = false;
  password2: string = '';
  // 找回密码
  step = 0;
  mobile = '';
  verify = '';
  countFirst = 1;
  count = 0;
  interval$: any;
  validate: object = {
    field: '',
    status: false,
    msg: '',
  };
  verifyData: object = {};
  error_type = '';
  checkMobileKey = '';
  passwordNewVisible = false;
  passwordNew: string = '';
  passwordNewVisible2 = false;
  passwordNew2: string = '';
  // 微信绑定手机号

  constructor(
    fb: FormBuilder,
    private router: Router,
    private settingsService: SettingsService,
    private socialService: SocialService,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private startupSrv: StartupService,
    public http: _HttpClient,
    public msg: NzMessageService,
    private message: NzMessageService,
    private loginService: LoginService,
    private common: CommonService,
    private activatedRoute: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams.type == undefined) {
        this.type = 1;
        this.user = sessionStorage.getItem('mobile_note');
        this.key = sessionStorage.getItem('check_key');
      } else {
        this.type = queryParams.type;
      }
    });
  }
  ngOnDestroy(): void {}
  sureSlider(e: any): void {
    console.log(e);
    this.verifyShow = e.target;
  }

  // 初次登录
  setPassword(): void {
    if (this.password == '') {
      this.common.msg.create('warning', '请输入登录密码');
      return;
    }
    if (this.error.password) {
      this.common.msg.create('warning', '登录密码的长度不能小于8');
      return;
    }
    if (this.password2 == '') {
      this.common.msg.create('warning', '请输入确认密码');
      return;
    }
    if (this.error.password2) {
      this.common.msg.create('warning', '两次密码不一致');
      return;
    }
    this.loginService
      .changePassword({
        key: this.key,
        password: this.password,
        check_password: this.password2,
      })
      .then((res) => {
        this.common.msg.create('success', '密码设置成功');
        setTimeout(() => {
          this.router.navigateByUrl('/passport/login');
        }, 700);
      });
  }

  // 找回密码
  // 短信验证码
  getCaptcha(): void {
    const mobileValidate = this.loginService.validate(this.mobile, 'mobile');
    this.validate['mobileNote'] = mobileValidate;
    if (!mobileValidate.status) {
      this.message.create('error', '手机号格式错误');
      return;
    }
    this.loginService
      .sendSms({
        mobile: this.mobile,
      })
      .then((res) => {
        this.countFirst++;
        this.count = 59;
        this.interval$ = setInterval(() => {
          this.count -= 1;
          if (this.count <= 0) {
            clearInterval(this.interval$);
          }
        }, 1000);
      });
  }
  stepNext(): void {
    const mobileValidate = this.loginService.validate(this.mobile, 'mobile');
    this.validate['mobile'] = mobileValidate;
    if (!mobileValidate.status) {
      this.message.create('error', '手机号格式错误');
      return;
    }
    if (this.verifyShow == false) {
      this.message.create('error', '请拖动滑块');
      return;
    }
    if (this.verify == '') {
      this.message.create('error', '请输入短信验证码');
      return;
    }
    this.loginService
      .checkMobile({
        mobile: this.mobile,
        code: this.verify,
      })
      .then((res) => {
        this.step = 1;
        this.checkMobileKey = res.key;
      });
  }
  passwordNewOk(): void {
    if (this.passwordNew == '') {
      this.common.msg.create('warning', '请输入登录密码');
      return;
    }
    if (this.error.passwordNew) {
      this.common.msg.create('warning', '登录密码的长度不能小于8');
      return;
    }
    if (this.passwordNew2 == '') {
      this.common.msg.create('warning', '请输入确认密码');
      return;
    }
    if (this.error.passwordNew2) {
      this.common.msg.create('warning', '两次密码不一致');
      return;
    }
    this.loginService
      .changePassword({
        key: this.checkMobileKey,
        password: this.passwordNew,
        check_password: this.passwordNew2,
      })
      .then((res) => {
        this.step = 2;
      });
  }

  // 密码
  passwordBlur(pass: any, attr: any): void {
    if (pass.length == 1) {
      if (pass[0].length < 8 && pass[0].length > 0) {
        this.error[attr] = true;
      } else {
        this.error[attr] = false;
      }
    } else {
      if (pass[0] != pass[1]) {
        this.error[attr] = true;
      } else {
        this.error[attr] = false;
      }
    }
  }

  // 微信绑定手机号
  relationOk(): void {
    const mobileValidate = this.loginService.validate(this.mobile, 'mobile');
    this.validate['mobile'] = mobileValidate;
    if (!mobileValidate.status) {
      this.message.create('error', '手机号格式错误');
      return;
    }
    if (this.verifyShow == false) {
      this.message.create('error', '请拖动滑块');
      return;
    }
    if (this.verify == '') {
      this.message.create('error', '请输入短信验证码');
      return;
    }
    this.loginService
      .checkMobile({
        mobile: this.mobile,
        code: this.verify,
      })
      .then((res) => {
        this.loginService
          .bindUser({
            key: res.key,
            oauth_id: sessionStorage.getItem('oauth_id'),
          })
          .then((res1) => {
            this.common.msg.create('success', '关联成功');
            this.tokenService.set({ token: res1['access_token'] });
            this.common.setCache('userInfo', res1);
            this.loginService.getMenuRoles().then((menu) => {
              this.common.setCache('menuRole', menu);
              this.router.navigate(['/home']).then();
            });
          });
      });
  }

  // 限制数字
  keyup(): void {
    if (this.mobile != '') {
      this.mobile = this.mobile.replace(/[^\d]/g, '');
    }
    if (this.verify != '') {
      this.verify = this.verify.replace(/[^\d]/g, '');
    }
  }

  /**
   * 校验表单
   */
  checkForm(): boolean {
    if (this.mobile == '') {
      this.validate = { field: 'mobile', status: false, msg: '请输入手机号' };
      return false;
    }
    if (this.password == '') {
      this.validate = { field: 'password', status: false, msg: '请输入密码' };
      return false;
    }
    if (this.verify == '') {
      this.validate = { field: 'verify', status: false, msg: '请输入验证码' };
      return false;
    }
    this.validate = { field: '', status: true, msg: '' };
  }

  /**
   * 取消报错
   * @param field
   */
  changeError(field: any): void {
    if (this.error_type == field) {
      this.error_type = '';
    }
  }
}
